"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;
exports.config = {
  production: {
    scriptSrc: '/content-editor/editor.min.js',
    customStyleSrc: '/content-editor/tekie-prism.min.css',
    fontStyleSrc: '/content-editor/skins/ui/tekie/customFonts.css',
    defaultURLPrefix: 'https://tekie-backend.s3.amazonaws.com'
  },
  staging: {
    scriptSrc: '/content-editor/editor.min.js',
    customStyleSrc: '/content-editor/tekie-prism.min.css',
    fontStyleSrc: '/content-editor/skins/ui/tekie/customFonts.css',
    defaultURLPrefix: 'https://tekie-tms-test.s3.amazonaws.com'
  }
};